import canvasTo from "./canvas_to.js"
import download from "./download.js"
import deprecations from "./deprecation.js"

const {conversions}           = canvasTo
const {downloadCanvasAsImage} = download


// `crop` is the export time crop key of every family. `cropSource` was the
// historical name on the image families ; it stays the *creation* time name
// (the source region of createImage / addImage), which is not deprecated.
const exportDeprecations = {cropSource: "crop"}


// Writes the whole export surface of a family over its own toCanvas(params) :
// the canvas_to conversions plus its download method. toCanvas is never defined
// here - it is the only per family part, and it must already be on `target`
// (a prototype or a plain api object). Every method forwards `params` to the
// conversion, and returns a promise as soon as toCanvas returns one.
//  - downloadName  : the family's download verb ("download" or "downloadAsImage")
//  - defaultName   : default file name, or a function of the object
//  - messagePrefix : prefix of the deprecation warnings
function attachExportMethods (target, {
    downloadName  = "download",
    defaultName   = "new_image",
    messagePrefix = "export"
} = {}) {

    renameDeprecatedExportParams(target, messagePrefix)

    Object.keys(conversions).forEach(methodName => {
        target[methodName] = function (params) {
            return fromCanvas(this, params, canvas => conversions[methodName](canvas, params))
        }
    })

    target[downloadName] = function (params = {}) {
        params = Object.assign({name: nameFor(this, defaultName)}, params)
        return fromCanvas(this, params, canvas => downloadCanvasAsImage(canvas, params))
    }
}


// every export funnels through the family's toCanvas, so this is the one place
// where a deprecated export param has to be renamed - a direct toCanvas call
// included.
function renameDeprecatedExportParams (target, messagePrefix) {
    const {toCanvas} = target

    if (!toCanvas) {
        throw new Error("attachExportMethods : the target must define its own toCanvas first")
    }

    target.toCanvas = function (params) {
        deprecations.options(params, exportDeprecations, messagePrefix)
        return toCanvas.call(this, params)
    }
}


function fromCanvas (object, params, convert) {
    const canvas = object.toCanvas(params)

    if (canvas && typeof canvas.then === "function") {
        return canvas.then(convert)
    }

    return convert(canvas)
}


function nameFor (object, defaultName) {
    if (typeof defaultName === "function") {
        return defaultName(object)
    }
    return defaultName
}


export default {attachExportMethods}


